import { createEmployee } from "./create-employee";

export const employees = {
	createEmployee,
};
